import App from 'app/app.js';
import 'app/service/BreadcrumbService.js';
import breadcrumbTemplate from './breadcrumb.html';
import './breadcrumb.scss';

class BreadcrumbController {
  constructor($scope, $location, BreadcrumbService) {
    this.breadcrumbs = [];

    $scope.$on('$routeChangeSuccess', () => {
      BreadcrumbService.updateBreadcrumbs();
      this.breadcrumbs = BreadcrumbService.getBreadcrumbs();
    });
  }

  showBreadcrumbs() {
    return this.breadcrumbs && this.breadcrumbs.length > 0;
  }
}

BreadcrumbController.$inject = ['$scope', '$location', 'BreadcrumbService'];

App.component('ltBreadcrumb', {
  template: breadcrumbTemplate,
  controller: BreadcrumbController,
  controllerAs: 'breadcrumb'
});
